import { Link } from 'react-router-dom';

export default function Success() {
  return (
    <main className="content">
      <div style={{ textAlign: 'center' }}>
        <h2>Deine Bestellung wurde erfolgreich eingereicht</h2>
        <Link to="/status" className="submit-btn" style={{ textDecoration: 'none', marginTop: '1rem' }}>
          Fortschritt überprüfen
        </Link>
      </div>
    </main>
  );
}
